import {
  ROUTE_CREATE_FAILURE,
  ROUTE_CREATE_REQUEST,
  ROUTE_CREATE_SUCCESS,
} from './types/RouteManagementCreateActionsTypes';

export function postRouteCreateRequestActionCreator(context,
  selectedAssetType,
  selectedComments,
  selectedDirection,
  selectedEndDate,
  selectedOutboundImpc,
  selectedInboundImpc,
  selectedPriority,
  selectedStartDate,
  selectedTransferLocations) {
  return {
    type: ROUTE_CREATE_REQUEST,
    payload: {
      appContext: context,
      params: {
        assetType: selectedAssetType,
        comments: selectedComments,
        direction: selectedDirection,
        endDate: selectedEndDate,
        outboundImpc: selectedOutboundImpc,
        inboundImpc: selectedInboundImpc,
        priority: selectedPriority,
        startDate: selectedStartDate,
        transferLocations: selectedTransferLocations,
      },
    },
  };
}

export function postRouteCreateSuccessActionCreator(data) {
  return {
    type: ROUTE_CREATE_SUCCESS,
    payload: data,
  };
}

export function postRouteCreateFailureActionCreator(error) {
  return {
    type: ROUTE_CREATE_FAILURE,
    payload: error,
    error: true,
  };
}
